import BannerSection from "../components/Banner";
import ProductCategory from "../components/ProductCategory";
import BlogSection from "../components/BlogSection";
import {Link} from "react-router-dom";
import CallToAction from "../components/CallToAction";

function Home() {
    return (
        <main className=" font-Inter pt-[72px] lg:pt-[109px]">
            <BannerSection/>
            <section className="py-16 sm:py-24 relative xl:mr-0 lg:mr-5 mr-0">
                <div className="w-full max-w-7xl px-4 md:px-5 lg:px-5 mx-auto">
                    <div className="w-full justify-start items-center xl:gap-12 gap-10 grid lg:grid-cols-2 grid-cols-1">
                        <div className="w-full flex-col justify-center lg:items-start items-center gap-10 inline-flex">
                            <div className="w-full flex-col justify-center items-start gap-8 flex">
                                <div className="w-full flex-col justify-center items-start gap-8 flex">
                                    <div className="flex-col justify-start lg:items-start items-center gap-4 flex">
                                        <div
                                            className="w-full flex-col justify-start lg:items-start items-center gap-3 flex">
                                            <h2 className="text-indigo-800 text-3xl sm:text-4xl font-semibold leading-normal lg:text-start text-center">
                                                Thương hiệu vải Timo
                                            </h2>
                                            <p className=" font-OpenSans text-gray-700 text-base font-normal leading-relaxed lg:text-start text-center">
                                                Với sứ mệnh mang đến chất liệu vải cao cấp, Timo không ngừng đổi mới để
                                                mang lại những sản phẩm chất lượng, bền vững và thân thiện với người
                                                dùng.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="w-full flex-col justify-center items-start gap-6 flex">
                                        <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-4">
                                            <div
                                                className="w-full p-3.5 rounded-xl min-h-[140px] border border-indigo-800 hover:border-gray-400 transition-all duration-700 ease-in-out flex flex-col justify-center items-center">
                                                <h4 className="text-gray-800 text-[1.10rem] font-semibold leading-9">4 Năm Kinh Nghiệm</h4>
                                                <p className=" font-OpenSans text-sm sm:text-[0.925rem] text-gray-700 text-center">Timo đã đồng hành cùng hàng nghìn khách hàng trên toàn quốc, cung cấp những sản phẩm hoàn hảo và dịch vụ tối ưu.</p>
                                            </div>
                                            <div
                                                className="w-full p-3.5 rounded-xl min-h-[140px] border border-indigo-800 hover:border-gray-400 transition-all duration-700 ease-in-out flex flex-col justify-center items-center">
                                                <h4 className="text-gray-800 text-[1.10rem] font-semibold leading-9">Hơn 1000 Màu Sắc Đa Dạng</h4>
                                                <p className=" font-OpenSans text-sm sm:text-[0.925rem] text-gray-700 text-center">Đa dạng chất liệu và màu sắc, bắt kịp xu hướng mới.</p>
                                            </div>
                                        </div>

                                        <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-4">
                                            <div
                                                className="w-full p-3.5 rounded-xl min-h-[140px] border border-indigo-800 hover:border-gray-400 transition-all duration-700 ease-in-out flex flex-col justify-center items-center">
                                                <h4 className="text-gray-800 text-[1.10rem] font-semibold leading-9">100% Chất Liệu Cao Cấp</h4>
                                                <p className=" font-OpenSans text-sm sm:text-[0.925rem] text-gray-700 text-center">Sản phẩm đạt tiêu chuẩn an toàn, bền đẹp, không gây kích ứng da, mang lại cảm giác thoải mái.</p>
                                            </div>
                                            <div
                                                className="w-full p-3.5 rounded-xl min-h-[140px] border border-indigo-800 hover:border-gray-400 transition-all duration-700 ease-in-out flex flex-col justify-center items-center">
                                                <h4 className="text-gray-800 text-[1.10rem] font-semibold leading-9">98% Khách Hàng Hài Lòng</h4>
                                                <p className=" font-OpenSans text-sm sm:text-[0.925rem] text-gray-700 text-center">Được tin dùng bởi các thương hiệu lớn và khách hàng cá nhân trên toàn quốc.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                            <Link
                                to="/about"
                                className="sm:w-fit w-full group px-3.5 py-2 bg-[#D4AF37] hover:bg-indigo-800 transition-all duration-700 ease-in-out justify-center items-center flex">
                        <span
                            className="px-1.5 tracking-tight text-white text-base font-semibold leading-6 group-hover:-translate-x-0.5 transition-all duration-700 ease-in-out">Đọc thêm</span>
                                <svg className="group-hover:translate-x-0.5 transition-all duration-700 ease-in-out"
                                     xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"
                                     fill="none">
                                    <path d="M6.75265 4.49658L11.2528 8.99677L6.75 13.4996" stroke="#FFFFFF"
                                          strokeWidth="1.6"
                                          strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </Link>
                        </div>
                        <div className="w-full lg:justify-start justify-center items-start flex">
                            <div
                                className="sm:w-[564px] w-full sm:h-[646px] h-full relative">
                                <img className="sm:mt-5 sm:ml-5 w-full h-full rounded-xl object-cover "
                                     src="/assets/images/aboutus/asa.jpg"
                                     alt="about Us image"/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <ProductCategory/>
            <section className="my-8">
                <div className="container mx-auto flex flex-col items-center pb-6 mb-4 md:p-10 md:px-12">
                    <h2 className="mx-2 text-indigo-800 text-3xl sm:text-4xl font-semibold leading-normal text-center">
                        Khách hàng nói gì về sản phẩm của Timo
                    </h2>
                </div>
                <div className="container mx-auto grid grid-cols-1 gap-8 lg:gap-10 md:px-10 md:pb-10 lg:grid-cols-2">
                    {/* Review 1 */}
                    <div className="flex flex-col items-center text-center px-6 lg:px-12">
                        <div className="relative w-full max-w-md">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                                 className="absolute top-0 left-0 w-8 h-8 text-gray-400">
                                <path fill="#33367b"
                                      d="M232,246.857V16H16V416H54.4ZM48,48H200V233.143L48,377.905Z"></path>
                                <path fill="#33367b"
                                      d="M280,416h38.4L496,246.857V16H280ZM312,48H464V233.143L312,377.905Z"></path>
                            </svg>
                            <p className="px-8 py-1 text-base font-OpenSans italic">
                                Chất vải của Timo thật sự rất tốt, mềm mịn và bền hơn so với những loại vải tôi từng sử dụng.
                                Tôi đã đặt hàng nhiều lần và chưa bao giờ thất vọng.
                            </p>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                                 className="absolute bottom-0 right-0 w-8 h-8 text-gray-400">
                                <path fill="#33367b"
                                      d="M280,185.143V416H496V16H457.6ZM464,384H312V198.857L464,54.1Z"></path>
                                <path fill="#33367b"
                                      d="M232,16H193.6L16,185.143V416H232ZM200,384H48V198.857L200,54.1Z"></path>
                            </svg>
                        </div>
                        <span className="w-12 h-1 my-2 rounded-lg bg-indigo-800"></span>
                        <p className="font-medium">Nguyễn Minh Huy</p>
                    </div>

                    {/* Review 2 */}
                    <div className="flex flex-col items-center text-center px-6 lg:px-12">
                        <div className="relative w-full max-w-md">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                                 className="absolute top-0 left-0 w-8 h-8 text-gray-400">
                                <path fill="#33367b"
                                      d="M232,246.857V16H16V416H54.4ZM48,48H200V233.143L48,377.905Z"></path>
                                <path fill="#33367b"
                                      d="M280,416h38.4L496,246.857V16H280ZM312,48H464V233.143L312,377.905Z"></path>
                            </svg>
                            <p className="px-8 py-1 text-base font-OpenSans italic">
                                Timo luôn cập nhật xu hướng vải mới nhất, giúp tôi dễ dàng lựa chọn được chất liệu phù hợp cho các thiết kế của mình.
                                Dịch vụ chăm sóc khách hàng cũng rất tuyệt vời!
                            </p>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                                 className="absolute bottom-0 right-0 w-8 h-8 text-gray-400">
                                <path fill="#33367b"
                                      d="M280,185.143V416H496V16H457.6ZM464,384H312V198.857L464,54.1Z"></path>
                                <path fill="#33367b"
                                      d="M232,16H193.6L16,185.143V416H232ZM200,384H48V198.857L200,54.1Z"></path>
                            </svg>
                        </div>
                        <span className="w-12 h-1 my-2 rounded-lg bg-indigo-800"></span>
                        <p className="font-medium">Lê Phương Anh</p>
                    </div>

                </div>
                <div
                    className="container mx-auto grid grid-cols-1 gap-8 lg:gap-10 md:px-10 md:pb-10 lg:grid-cols-2 mt-10">
                    {/* Review 1 */}
                    <div className="flex flex-col items-center text-center px-6 lg:px-12">
                        <div className="relative w-full max-w-md">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                                 className="absolute top-0 left-0 w-8 h-8 text-gray-400">
                                <path fill="#33367b"
                                      d="M232,246.857V16H16V416H54.4ZM48,48H200V233.143L48,377.905Z"></path>
                                <path fill="#33367b"
                                      d="M280,416h38.4L496,246.857V16H280ZM312,48H464V233.143L312,377.905Z"></path>
                            </svg>
                            <p className="px-8 py-1 text-base font-OpenSans italic">
                                Tôi đã tìm kiếm một thương hiệu vải cao cấp trong thời gian dài, và Timo là lựa chọn hoàn hảo.
                                Chất vải bền màu, dễ giặt, không bị xù lông sau nhiều lần sử dụng.
                            </p>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                                 className="absolute bottom-0 right-0 w-8 h-8 text-gray-400">
                                <path fill="#33367b"
                                      d="M280,185.143V416H496V16H457.6ZM464,384H312V198.857L464,54.1Z"></path>
                                <path fill="#33367b"
                                      d="M232,16H193.6L16,185.143V416H232ZM200,384H48V198.857L200,54.1Z"></path>
                            </svg>
                        </div>
                        <span className="w-12 h-1 my-2 rounded-lg bg-indigo-800"></span>
                        <p className="font-medium">Trần Thanh Nam</p>
                    </div>

                    {/* Review 2 */}
                    <div className="flex flex-col items-center text-center px-6 lg:px-12">
                        <div className="relative w-full max-w-md">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                                 className="absolute top-0 left-0 w-8 h-8 text-gray-400">
                                <path fill="#33367b"
                                      d="M232,246.857V16H16V416H54.4ZM48,48H200V233.143L48,377.905Z"></path>
                                <path fill="#33367b"
                                      d="M280,416h38.4L496,246.857V16H280ZM312,48H464V233.143L312,377.905Z"></path>
                            </svg>
                            <p className="px-8 py-1 text-base font-OpenSans italic">
                                Tôi là người khá kỹ tính khi chọn vải, nhưng với Timo, tôi hoàn toàn yên tâm.
                                Sản phẩm đúng mô tả, chất lượng cao, đặc biệt là giá cả hợp lý so với chất lượng.
                            </p>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                                 className="absolute bottom-0 right-0 w-8 h-8 text-gray-400">
                                <path fill="#33367b"
                                      d="M280,185.143V416H496V16H457.6ZM464,384H312V198.857L464,54.1Z"></path>
                                <path fill="#33367b"
                                      d="M232,16H193.6L16,185.143V416H232ZM200,384H48V198.857L200,54.1Z"></path>
                            </svg>
                        </div>
                        <span className="w-12 h-1 my-2 rounded-lg bg-indigo-800"></span>
                        <p className="font-medium">Võ Hải Đăng</p>
                    </div>

                </div>
            </section>
            <BlogSection/>
            <CallToAction/>

        </main>
    );
}

export default Home;
